__turbopack_context__.v({
  "authDescription": "traceTile-module-scss-module__eQ9Hsa__authDescription",
  "fallbackContainer": "traceTile-module-scss-module__eQ9Hsa__fallbackContainer",
  "unAuthDescription": "traceTile-module-scss-module__eQ9Hsa__unAuthDescription",
});
